import { z } from 'zod';
import { defineEndpoint } from '../define';
import { ReleaseDetailSchema } from './shapes';

/**
 * One-button promote (UCH-436): create the next environment's draft from this
 * succeeded/published release — same version, same ref+commitSha, new build
 * number. The caller confirms the new draft through the normal flow.
 */
export const promoteRelease = defineEndpoint({
  method: 'POST',
  path: '/v1/releases/:releaseId/promote',
  params: z.object({ releaseId: z.string().uuid() }),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({ data: ReleaseDetailSchema }),
  successStatus: 201,
});
